// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_main__UQlyv {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  z-index: 2;
}

.modal_modal__Nszx8 {
  margin: auto;
  background: white;
  border-radius: 0.3em;
  overflow: hidden;
  animation: modal_lds-easeIn__jFLNH 0.2s cubic-bezier(0, 0.5, 0.5, 1);
}

@keyframes modal_lds-easeIn__jFLNH {
  0% {
    transform: scale(0.8);
  }
  50%,
  100% {
    transform: scale(1);
  }
}

.modal_header__WylpV {
  padding: 0.5rem 1rem;
  display: flex;
  font-weight: 600;
  font-size: 1.5rem;
  color: white;
}
.modal_header__WylpV button:last-child {
  margin-left: auto;
  font-weight: 600;
  font-size: 1.2rem;
  color: white;
  background: none;
  border: none;
  transition-duration: 200ms;
}
.modal_header__WylpV button:last-child:hover {
  color: #d63031;
  transition-duration: 200ms;
}

.modal_divider__ofDAW {
  margin: 0;
}

.modal_footer__GdlGs {
  /* border-top : 1px solid #636e72; */
  display: flex;
  justify-content: center;
}

.modal_body__t765M {
  padding: 0.5em;
  overflow: auto;
  max-height: 70vh;
}

.modal_button__GRC0s {
  opacity: 0.8;
  padding: 0.5em 1em;
  margin: 0.5em 1em;
  border: none;
  border-radius: 0.4em;
  font-weight: 600;
  transition-duration: 200ms;
}
.modal_button__GRC0s:hover {
  opacity: 1;
  transition-duration: 200ms;
}

.modal_footerButton__3aPUn {
  flex-grow: 1;
  /* opacity : 0.8; */
  padding: 0.5em 1em;
  border: none;
  font-weight: 600;
  font-size: 1.2em;
  transition-duration: 200ms;
}

.modal_footerDisabledButton__y\\+N9A {
  background-color: rgb(75, 75, 75);
  flex-grow: 1;
  /* opacity : 0.8; */
  padding: 0.5em 1em;
  border: none;
  font-weight: 600;
  font-size: 1.2em;
  transition-duration: 200ms;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/modal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,oEAAuD;AACzD;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB","sourcesContent":[".main {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  z-index: 2;\n}\n\n.modal {\n  margin: auto;\n  background: white;\n  border-radius: 0.3em;\n  overflow: hidden;\n  animation: lds-easeIn 0.2s cubic-bezier(0, 0.5, 0.5, 1);\n}\n\n@keyframes lds-easeIn {\n  0% {\n    transform: scale(0.8);\n  }\n  50%,\n  100% {\n    transform: scale(1);\n  }\n}\n\n.header {\n  padding: 0.5rem 1rem;\n  display: flex;\n  font-weight: 600;\n  font-size: 1.5rem;\n  color: white;\n}\n.header button:last-child {\n  margin-left: auto;\n  font-weight: 600;\n  font-size: 1.2rem;\n  color: white;\n  background: none;\n  border: none;\n  transition-duration: 200ms;\n}\n.header button:last-child:hover {\n  color: #d63031;\n  transition-duration: 200ms;\n}\n\n.divider {\n  margin: 0;\n}\n\n.footer {\n  /* border-top : 1px solid #636e72; */\n  display: flex;\n  justify-content: center;\n}\n\n.body {\n  padding: 0.5em;\n  overflow: auto;\n  max-height: 70vh;\n}\n\n.button {\n  opacity: 0.8;\n  padding: 0.5em 1em;\n  margin: 0.5em 1em;\n  border: none;\n  border-radius: 0.4em;\n  font-weight: 600;\n  transition-duration: 200ms;\n}\n.button:hover {\n  opacity: 1;\n  transition-duration: 200ms;\n}\n\n.footerButton {\n  flex-grow: 1;\n  /* opacity : 0.8; */\n  padding: 0.5em 1em;\n  border: none;\n  font-weight: 600;\n  font-size: 1.2em;\n  transition-duration: 200ms;\n}\n\n.footerDisabledButton {\n  background-color: rgb(75, 75, 75);\n  flex-grow: 1;\n  /* opacity : 0.8; */\n  padding: 0.5em 1em;\n  border: none;\n  font-weight: 600;\n  font-size: 1.2em;\n  transition-duration: 200ms;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `modal_main__UQlyv`,
	"modal": `modal_modal__Nszx8`,
	"lds-easeIn": `modal_lds-easeIn__jFLNH`,
	"header": `modal_header__WylpV`,
	"divider": `modal_divider__ofDAW`,
	"footer": `modal_footer__GdlGs`,
	"body": `modal_body__t765M`,
	"button": `modal_button__GRC0s`,
	"footerButton": `modal_footerButton__3aPUn`,
	"footerDisabledButton": `modal_footerDisabledButton__y+N9A`
};
export default ___CSS_LOADER_EXPORT___;
